module.exports = __webpack_public_path__ + "static/ethical-8c87457ef72ac35c702eeb04825af68b.png";